module.exports = __webpack_public_path__ + "static/media/icon-checkmark-blue.1900865e.svg";